"use client";

import { FILTER_SORT_OPTIONS } from "@/app/utilities/constants";
import Image from "next/image";

// ─── Icons ────────────────────────────────────────────────────────────────────
const XIcon: React.FC<{ size?: number }> = ({ size = 16 }) => <Image
      src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}lib-icon/cross-icon-new.svg`}
      alt="cross icon"
      title="cross icon"
      width={size}
      height={size}
  />;

const CheckIcon: React.FC<{ size?: number }> = ({ size = 15 }) => (
  <Image
      src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}check.svg`}
      alt="check"
      title="check"
      width={size}
      height={size}
  />
);

const ArrowRightIcon: React.FC<{ size?: number }> = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    className="inline-block mx-1 align-[-1px]"
  >
    <line x1="4" y1="12" x2="20" y2="12" />
    <polyline points="14 6 20 12 14 18" />
  </svg>
);

// ─── Props ────────────────────────────────────────────────────────────────────
interface MobileSortSheetProps {
  open: boolean;
  onClose: () => void;
  sortValue: string;
  onSortChange: (value: string) => void;
  sortAppliedTrackingClass?: string;
  is_latest: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function MobileSortSheet({
  open,
  onClose,
  sortValue,
  onSortChange,
  sortAppliedTrackingClass = '',
  is_latest = false
}: MobileSortSheetProps) {
  const filtersToShow = is_latest ? FILTER_SORT_OPTIONS.filter(item=>item.value!="sort_order_asc") : FILTER_SORT_OPTIONS.filter(item=>item.value!="launch_date_desc");
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-[rgba(0,0,0,0.45)] z-[200] transition-[opacity] duration-300 ease-[ease] ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={onClose}
      />

      {/* Sheet */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-[20px] z-[201] max-h-[90vh] flex flex-col transition-[transform] duration-320 ease-[cubic-bezier(0.32,0,0.15,1)] ${open ? "[transform:translateY(0)]" : "[transform:translateY(100%)]"}`}>
        <div className="flex items-center justify-between py-4 px-5 border-b border-b-[#f3f4f6] shrink-0">
          <p className="flex items-center gap-2 text-[17px] font-bold text-[#111] m-0">Sort By</p>
          <button
            className="bg-transparent border-none cursor-pointer p-1 flex items-center text-[#6b7280]"
            onClick={onClose}
            type="button"
          >
            <XIcon />
          </button>
        </div>

        <div style={{ padding: "12px 20px 24px" }}>
          {filtersToShow.map((opt) => {
            const isActive = sortValue === opt.value;
            return (
              <div
                key={opt.value}
                className={`flex items-center justify-between py-3.5 px-4 rounded-[10px] text-[15px] font-normal cursor-pointer mb-1 transition-[background] duration-120 ease-[ease] ${isActive ? "bg-[#008C8B] text-white hover:bg-[#008C8B]" : "text-[#1f2937] hover:bg-[#f9fafb]"} ${sortAppliedTrackingClass}`}
                onClick={() => {
                  onSortChange(opt.value);
                  onClose();
                }}
              >
                <span className="flex items-center">
                  {opt.label}
                  {opt.labelTo && <><ArrowRightIcon />{opt.labelTo}</>}
                </span>
                {isActive && <Image
                    src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}check.svg`}
                    alt="check"
                    title="check"
                    width={16}
                    height={16}
                    className="ml-2"
                />}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
